var DetailGppStaticController = (function () {
    function DetailGppStaticController(topic, settings, socket, env, $filter, Dialog, _, $state) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.env = env;
        this.$filter = $filter;
        this.Dialog = Dialog;
        this._ = _;
        this.$state = $state;
        this.comp = 'gpp';
        this.diffArray = 'gppMissing';
        this.paSiteVisibe = false;
        this.paSiteEditable = true;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.timestamp = this.getTimestamp();
        var contactEmail = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5 ?
            this.topic.topic.contactEmail :
            _.get(this.topic.checksData, 'inboundInitial.inbound.incentiveInformation.incentiveDetail.createdBy');
        var oppVersion = _.get(this.topic.checksData, 'uiVersion', 1);
        this.getNewUIInfo = {
            uiVersion: oppVersion,
            email: contactEmail,
            cmr: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.incentiveCMRNumber'),
            accountInfo: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.account.sites'),
            isRestricted: _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.opportunity.isRestricted'),
            bpCountry: function () {
                return _this.topic.getCountryFullName(_.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.country'));
            },
            accountCountry: function () {
                return _this.topic.getCountryFullName(_.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrCountryCode'));
            },
            bpName: function () {
                var bpFirstName;
                var bpLastName;
                if (oppVersion && oppVersion <= _this.OPP_VERSION_4) {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpLastName');
                }
                else {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpLastName');
                }
                return bpFirstName + " " + bpLastName;
            },
            getSVISumbitDateName: function () {
                return _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                    ? 'Submit Date:'
                    : 'Submit Date for CVR Eligibility:';
            },
            getAccountValue: function (accountName) {
                var generics = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics', []);
                var accountObj = generics.find(function (generic) { return generic.name === accountName; });
                return accountObj ? accountObj.value : '';
            },
            externalLinks: function (link) { return _this.topic.externalLinks[link]; }
        };
    }
    DetailGppStaticController.prototype.getDcId = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticClientId');
        }
        else {
            return this.getNewUIInfo.getAccountValue('domesticClientId');
        }
    };
    DetailGppStaticController.prototype.getRevenueV5 = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityAmount');
        }
        return undefined;
    };
    DetailGppStaticController.prototype.getOppCurrencyV5 = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.opportunityCurrency');
        }
        return undefined;
    };
    DetailGppStaticController.prototype.getDbg = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_5) {
            return _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrDomesticBuyingGroup');
        }
        else {
            return this.getNewUIInfo.getAccountValue('domesticBuyingGroup');
        }
    };
    DetailGppStaticController.prototype.isSiteIdDataAvailable = function () {
        return this.topic.siteIdData && this.topic.siteIdData.length;
    };
    /**
     * Return timestamp based on which tab was clicked
     * @returns number
     * @memberof DetailGppStaticController
     */
    DetailGppStaticController.prototype.getTimestamp = function () {
        var activeTab = _.words(this.$state.current.name)[1];
        if (activeTab === 'eligibility') {
            return this.topic.topic["gpp"][0].timestamp;
        }
        if (activeTab === 'general') {
            if (this.topic.topic['gppOnAssign']) {
                return this.topic.topic['gppOnAssign'][0].timestamp;
            }
            // If the gppOnAssign object is not exist,
            // set timestamp from gpp_live - ie: the latest data
            return this.topic.topic['gpp_live'][0].timestamp;
        }
    };
    DetailGppStaticController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailGppStaticController.prototype.changePaVisible = function () {
        this.paSiteVisibe = !this.paSiteVisibe;
    };
    DetailGppStaticController.prototype.getRestricted = function () {
        return this.isV4OrLess() ? this.getRestrictedV4() : this.getRestrictedV5();
    };
    DetailGppStaticController.prototype.getRestrictedV4 = function () {
        switch (this.getNewUIInfo.isRestricted) {
            case 'RESTNOT':
                return 'Not Restricted';
            case 'RESTOPCL':
                return 'Restricted to opportunity team, client team and incentive review team';
            case 'RESTOPTY':
                return 'Restricted to opportunity team and incentive review team';
            default:
                return '';
        }
    };
    DetailGppStaticController.prototype.getRestrictedV5 = function () {
        switch (this.topic.topic.isRestr) {
            case 'N':
                return 'Not Restricted';
            case 'Y':
                return 'Restricted';
            default:
                return '';
        }
    };
    DetailGppStaticController.prototype.showAccountArrayList = function () {
        var items = {
            dialogName: this.getNewUIInfo.accountInfo,
            columnHeaders: [
                'CMR Number',
                'Site ID',
                'Account Name',
                'Address',
                'City',
                'State',
                'Postal Code',
                'Country'
            ]
        };
        this.Dialog.updateValidForm(event, items, 'accountInfoData-dialog.html');
    };
    DetailGppStaticController.prototype.showSiteIdData = function () {
        var items = {
            siteIdData: this.topic.siteIdData,
            headers: [
                'CMR Number',
                'Site ID',
                'Account Name',
                'Address',
                'City',
                'State',
                'Postal Code',
                'Country'
            ]
        };
        this.Dialog.updateValidForm(event, items, 'siteIdData-dialog.html');
    };
    DetailGppStaticController.prototype.excelSiteIDsExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: 'siteids',
                    siteIdsArray: this.getNewUIInfo.accountInfo.map(function (element) {
                        element.cntryCode2 = undefined;
                        return element;
                    })
                }
            }
        });
    };
    DetailGppStaticController.prototype.excelSiteIdsV5Export = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: 'siteIdsV5',
                    siteIdsArray: this.topic.siteIdData.map(function (element) {
                        element.cntryCode2 = undefined;
                        return element;
                    })
                }
            }
        });
    };
    DetailGppStaticController.prototype.getMySAChange = function (field, type) {
        var refresh = this.topic.isInEligibilityStatus() ? '  Click Refresh Opportunity Data to overwrite.' : '';
        var value;
        if (type === 'date') {
            value = this.$filter('date')(new Date(Number(this.topic.topic.gpp_live[0][field])), this.settings.up.preferences.dateFormat, '+1200');
        }
        else if (type === 'number') {
            value = this.$filter('number')(this.topic.topic.gpp_live[0][field], 2);
        }
        else {
            value = this.topic.topic.gpp_live[0][field];
        }
        return "This value has changed at MySA.  The new value is " + value + "." + refresh;
    };
    DetailGppStaticController.prototype.reload = function () {
        // not actual anymore
        // if (this.topic.updatePartialSocketStatus(['gpp', 'comments$eligibility'], 'Updating')) {
        //     this.socket.emit('module', {
        //         module: {
        //             application: 'dmt',
        //             bID: this.topic.topicBrowserID,
        //             data: {
        //                 opp: this.topic.topic.opp, //This will run a query in DB2 so needs to be OPP
        //                 type: ['gpp', 'comments$eligibility'],
        //                 unid: this.topic.topic._id,
        //             },
        //             function: 'updateEligGppData',
        //             partial: true,
        //             script: '/detail/general/general',
        //             token: this.env.user.token,
        //         },
        //     });
        // } else {
        //     alert('Problem when updating eligibility gpp');
        // }
    };
    DetailGppStaticController.$inject = ['topic', 'settings', 'socket', 'env', '$filter', 'Dialog', '_', '$state'];
    return DetailGppStaticController;
}());
var DetailGppStaticComponent = (function () {
    function DetailGppStaticComponent() {
        this.templateUrl = 'detail-eligibility-gpp.html';
        this.controllerAs = 'vm';
        this.controller = DetailGppStaticController;
    }
    return DetailGppStaticComponent;
}());
angular
    .module('application')
    .component('detailGppStatic', new DetailGppStaticComponent());

//# sourceMappingURL=detail.general.gpp.static.component.js.map
